import React from 'react';
import { beatsIcon, PathElement } from '@chordbaker/design';

const paths = beatsIcon.elements as PathElement[];

interface BeatsIconProps {
  size?: number;
  color?: string;
}

/** Metronome: the beats button in the slot action pill. */
const BeatsIcon: React.FC<BeatsIconProps> = ({ size = beatsIcon.defaultSize, color = 'currentColor' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={beatsIcon.viewBox}
    fill={beatsIcon.fill}
    stroke={color}
    strokeWidth={beatsIcon.strokeWidth}
    strokeLinecap={beatsIcon.strokeLinecap as React.SVGAttributes<SVGSVGElement>['strokeLinecap']}
    strokeLinejoin={beatsIcon.strokeLinejoin as React.SVGAttributes<SVGSVGElement>['strokeLinejoin']}
    aria-hidden="true"
  >
    {paths.map(path => (
      <path key={path.d} d={path.d} />
    ))}
  </svg>
);

export default BeatsIcon;
